export const groupByProduct = (items) => {
    const groups = new Map();
    items.forEach(item => {
        const group = groups.get(item.id);
        group ? group.push(item) : groups.set(item.id, [item]);
    });
    return [...groups.values()];
};
